<template>
  <div class="footer-nav">
    <div class="container">
      <div v-if="mq.mdPlus" class="footer-links">
        <div>
          <div class="footer-links-heading">Shop</div>
          <ul>
            <li>
              <a class="footer-link" href="/collections/all">Shop all</a>
            </li>
            <li>
              <a class="footer-link" href="/collections/dresses">Dresses</a>
            </li>
            <li>
              <a class="footer-link" href="/collections/beachwear">Beachwear</a>
            </li>
            <li>
              <a class="footer-link" href="/collections/jumpsuits">Jumpsuits</a>
            </li>
            <li>
              <a class="footer-link" href="/collections/tailoring">Tailoring</a>
            </li>
            <li>
              <a class="footer-link" href="/collections/forever-loves"
                >Forever Loves</a
              >
            </li>
            <li>
              <a class="footer-link" href="/collections/born-in-flames"
                >Born In Flames</a
              >
            </li>
            <li>
              <a class="footer-link" href="/collections/the-rhapsody-collection"
                >The Rhapsody Collection</a
              >
            </li>
            <li>
              <a class="footer-link" href="/collections/the-solara-collection"
                >The Solara Collection</a
              >
            </li>
            <li>
              <a
                class="footer-link"
                href="/collections/another-time-another-world"
                >Another Time, Another World</a
              >
            </li>
          </ul>
        </div>
        <div>
          <div class="footer-links-heading">Journal</div>
          <ul>
            <li>
              <a class="footer-link" href="/blogs/journal">Read All Stories</a>
            </li>
            <li>
              <a class="footer-link" href="/blogs/journal">Style Notes</a>
            </li>
            <li>
              <a class="footer-link" href="/blogs/journal">In The Stars</a>
            </li>
            <li><a class="footer-link" href="/blogs/journal">Muses</a></li>
            <li>
              <a class="footer-link" href="/blogs/journal"
                >Behind the Collection</a
              >
            </li>
            <li>
              <a class="footer-link" href="/blogs/journal">Travel Journal</a>
            </li>
          </ul>
        </div>
        <div>
          <div class="footer-links-heading">Company</div>
          <ul>
            <li>
              <a class="footer-link" href="/pages/sustainability"
                >Approach to Sustainability</a
              >
            </li>
          </ul>
        </div>
        <div>
          <div class="footer-links-heading">Account</div>
          <ul>
            <li>
              <Button transparent @click="setSlideSignUp(true)"
                >Create Account</Button
              >
            </li>
            <li>
              <Button transparent @click="setSlideLogin(true)">Login</Button>
            </li>
            <li><a class="footer-link" href="/account">Your Orders</a></li>
            <li>
              <a class="footer-link" href="/account">Your Account Details</a>
            </li>
            <li>
              <a class="footer-link" href="/pages/members">Members Only.</a>
            </li>
          </ul>
        </div>
        <div>
          <div class="footer-links-heading">Location</div>
          <ul>
            <li>
              <form class="form">
                <label class="field field--select">
                  <span class="field__label">Currency:</span>
                  <div class="input input--select">
                    <select
                      v-model="currencyCode"
                      class="input__element"
                      @change="handleCurrencyChange"
                    >
                      <option :selected="currencyCode === 'GBP'" value="gbp">
                        GBP
                      </option>
                      <option :selected="currencyCode === 'EUR'" value="eur">
                        EUR
                      </option>
                      <option :selected="currencyCode === 'USD'" value="usd">
                        USD
                      </option>
                      <option :selected="currencyCode === 'AUD'" value="aud">
                        AUD
                      </option>
                    </select>
                  </div>
                </label>
              </form>
            </li>
          </ul>
        </div>
        <div>
          <div class="footer-links-heading">Support</div>
          <ul>
            <li>
              <a class="footer-link" href="/pages/returns">Returns & Refunds</a>
            </li>
            <li>
              <a class="footer-link" href="/pages/help?category=my-orders"
                >Orders</a
              >
            </li>
            <li>
              <a class="footer-link" href="/pages/help?category=rewards"
                >Rewards</a
              >
            </li>
            <li>
              <a class="footer-link" href="/pages/help?category=delivery"
                >Shipping & Delivery</a
              >
            </li>
            <li>
              <a class="footer-link" href="/pages/help?category=technical"
                >Technical</a
              >
            </li>
            <li>
              <a class="footer-link" href="mailto:customercare@ratandboa.com">
                Send us an email
              </a>
            </li>
            <li>
              <a class="footer-link" href="/pages/returns-portal/"
                >Start a return</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div v-else>
        <Accordion class="footer-link-group" :show-arrow="true">
          <template #header>Shop</template>
          <template #body>
            <ul>
              <li>
                <a class="footer-link" href="/collections/all">Shop all</a>
              </li>
              <li>
                <a class="footer-link" href="/collections/dresses">Dresses</a>
              </li>
              <li>
                <a class="footer-link" href="/collections/beachwear"
                  >Beachwear</a
                >
              </li>
              <li>
                <a class="footer-link" href="/collections/the-solara-collection"
                  >The Solara Collection</a
                >
              </li>
              <li>
                <a class="footer-link" href="/collections/forever-loves"
                  >Forever Loves</a
                >
              </li>
            </ul>
          </template>
        </Accordion>

        <Accordion class="footer-link-group" :show-arrow="true">
          <template #header>The Journal</template>
          <template #body>
            <ul>
              <li>
                <a class="footer-link" href="/blogs/journal"
                  >Read All Stories</a
                >
              </li>
              <li>
                <a class="footer-link" href="/blogs/journal">Style Notes</a>
              </li>
              <li>
                <a class="footer-link" href="/blogs/journal">In The Stars</a>
              </li>
              <li><a class="footer-link" href="/blogs/journal">Muses</a></li>
              <li>
                <a class="footer-link" href="/blogs/journal"
                  >Behind the Collection</a
                >
              </li>
              <li>
                <a class="footer-link" href="/blogs/journal">Travel Journal</a>
              </li>
            </ul>
          </template>
        </Accordion>

        <Accordion class="footer-link-group" :show-arrow="true">
          <template #header>Company</template>
          <template #body>
            <ul>
              <li>
                <a class="footer-link" href="/pages/sustainability"
                  >Approach to Sustainability</a
                >
              </li>
            </ul>
          </template>
        </Accordion>

        <Accordion class="footer-link-group" :show-arrow="true">
          <template #header>Account</template>
          <template #body>
            <ul>
              <li>
                <Button transparent @click="setSlideSignUp(true)"
                  >Create Account</Button
                >
              </li>
              <li>
                <Button transparent @click="setSlideLogin(true)">Login</Button>
              </li>
              <li><a class="footer-link" href="/account">Your Orders</a></li>
              <li>
                <a class="footer-link" href="/account">Your Account Details</a>
              </li>
              <li>
                <a class="footer-link" href="/account">Members Only.</a>
              </li>
            </ul>
          </template>
        </Accordion>

        <Accordion class="footer-link-group" :show-arrow="true">
          <template #header>Support</template>
          <template #body>
            <ul>
              <li>
                <a class="footer-link" href="/pages/help?category=delivery"
                  >Delivery</a
                >
              </li>
              <li>
                <a class="footer-link" href="/pages/help?category=exchange"
                  >Exchange</a
                >
              </li>
              <li>
                <a class="footer-link" href="/pages/help?category=my-orders"
                  >Orders</a
                >
              </li>
              <li>
                <a
                  class="footer-link"
                  href="/pages/help?category=returns-refunds"
                  >Returns & Refunds</a
                >
              </li>
              <li>
                <a class="footer-link" href="/pages/help?category=rewards"
                  >Rewards</a
                >
              </li>
              <li>
                <a class="footer-link" href="/pages/help?category=technical"
                  >Technical</a
                >
              </li>
              <li>
                <a href="mailto:customercare@ratandboa.com" class="footer-link">
                  Send us an email
                </a>
              </li>
              <li>
                <a class="footer-link" href="/pages/returns-portal/"
                  >Start a return</a
                >
              </li>
            </ul>
          </template>
        </Accordion>
        <form class="form">
          <label class="field field--select footer-link footer-link--single">
            <span class="field__label">Currency:</span>
            <div class="input input--select">
              <select
                v-model="currencyCode"
                class="input__element"
                @change="handleCurrencyChange"
              >
                <option value="gbp">GBP</option>
                <option value="eur">EUR</option>
                <option value="usd">USD</option>
                <option value="aud">AUD</option>
              </select>
            </div>
          </label>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Accordion from "@/components/Accordion.vue";
import Button from "@/components/Button.vue";

export default {
  name: "FooterLinks",
  components: {
    Button,
    Accordion,
  },
  inject: ["mq"],
  computed: {
    ...mapGetters("app", ["currencyCode"]),
  },
  methods: {
    ...mapActions("app", ["changeCurrency", "setSlideLogin", "setSlideSignUp"]),
    handleCurrencyChange(event) {
      const value = event.target.value;
      this.changeCurrency(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form";

.footer-nav {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: $color-light;

  @include respond-above(md) {
    padding: 50px 0;
  }

  .form {
    line-height: 0;
  }

  .form .field--select {
    .field__label,
    .input--select {
      display: inline-block !important;
      font-family: $heading-font-family;
      font-size: 12px;
      font-weight: 400;

      @include respond-above(md) {
        font-family: $body-font-family;
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.49px;
        line-height: 1;
        text-transform: uppercase;
      }
    }

    .input--select::after {
      font-size: 10px;
      z-index: 1;
      height: 10px;
      width: 10px;
    }

    .input__element {
      background: none;
      border: none;
      font-family: $heading-font-family;
      outline: none;
      margin-left: 5px !important;
      padding-right: 15px;
      padding-top: 0;
      padding-bottom: 0;
      margin-bottom: 0 !important;
      position: relative;
      z-index: 2;

      @include respond-above(md) {
        font-family: $body-font-family;
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.49px;
        line-height: 1;
        text-transform: uppercase;
      }
    }
  }
}

.footer-links {
  display: flex;
  gap: 30px;
  justify-content: space-between;
  padding: 0 20px;

  ::v-deep(.button) {
    color: $color-dark;
    font-size: 10px;
    line-height: 1;
    margin: 0 0 10px 0;
    padding: 0;
    display: block;
  }
}

.footer-links-heading {
  color: $color-dark;
  font-family: $heading-font-family;
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 30px 0;
}

.footer-link {
  display: block;
  color: $color-dark;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.55px;
  padding: 14px 0;
  margin: 0 0 10px 0;
  text-decoration: none;
  text-transform: uppercase;

  @include respond-above(md) {
    padding: 0;
  }
}

.footer-link-group {
  ::v-deep(.accordion__header) {
    background: none;
    outline: none;
    border: none;
    text-transform: uppercase;
    padding: 14px 0;
    font-size: 12px;
    width: 100%;
    text-align: left;
  }
  ::v-deep(.accordion__body) {
    display: block;
    height: auto;
  }
  ::v-deep(.button) {
    color: $color-dark;
    font-size: 10px;
    line-height: 1;
    margin: 0 0 10px 0;
    padding: 14px 0;
  }
}
</style>
